import React from 'react'
import PropTypes from 'prop-types'
import { noop } from 'lodash'

import useScrollLayout from './useScrollBox'

import { Style } from './style'

const ScrollBoxHorizontal = React.forwardRef(
  ({ className, step, children, renderLeft, renderRight }, ref) => {
    const {
      hasOverflowHorizontal,
      canScrollLeft,
      canScrollRight,
      scrollLeft,
      scrollRight,
    } = useScrollLayout({
      ref,
    });
   
    return (
      <React.Fragment>
        {renderLeft({ hasOverflowHorizontal, canScrollLeft, step, scrollLeft })}
        <Style className={className} ref={ref}>
          {children}
        </Style>
        {renderRight({ hasOverflowHorizontal, canScrollRight, step, scrollRight })}
      </React.Fragment>
    );
  }
);

ScrollBoxHorizontal.defaultProps = {
  step: 100,
  className: '',
  renderLeft: noop,
  renderRight: noop,
}

ScrollBoxHorizontal.propTypes = {
  step: PropTypes.number,
  className: PropTypes.string,
  renderLeft: PropTypes.func,
  renderRight: PropTypes.func,
}

export default ScrollBoxHorizontal
